import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { siteSpecificData } from '../../../environments/site-specific-data';
import { AboutModel } from '../models/about-model';
import { UrlBuilderService } from '../../common/services/url-builder.service';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class AboutHttpService {

  constructor(private http: HttpClient, private urlBuilderService: UrlBuilderService) { }

  getAboutDetails(product: string): Observable<AboutModel> {
    const url = this.urlBuilderService.getIdentityServerUrl(`about/${product}`);
    return this.http
      .get<AboutModel>(url).pipe(
        map(about => about || undefined)
      );
  }

}
